enum LoadingState {
  loading = "loading",
  success = "success",
  error = "error",
}

export {
  LoadingState
}
